// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__lj6VE","overallTable":"style__overallTable__2Bm4u"};